<div class="d-flex flex-column justify-content-center">
  <div class="row loading-row" *ngIf="loading">
    <div class="col-12">
      <div class="spinner">
        <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      </div>
    </div>
  </div>

  <form (submit)="resetPassword()" class="form-inline" [formGroup]="form" >
    <span class="info" @loginItem>Forgot your password? Enter your email below, and we will send you instructions of how to set a new one.</span>
    <app-alert [message]="message" [type]="messageType"></app-alert>
    <div class="login-input-container" @loginItem>
      <label class="sr-only" for="email">Email</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><img src="./assets/ui/svg/grey/icon-contact-us.svg"/></div>
        </div>
        <div class="vertical-divider"></div>
        <input type="text" id="email" name="email" placeholder="Email" #usernameinput formControlName="email" autocomplete="email">
      </div>
    </div>

    <button  @loginItem type="submit" [class]="loading || !form.valid ? 'non-active' : 'active'" [disabled]="loading || !form.valid">Reset my password</button>

  </form>
  <div class="bottom-row" @loginItem>
    <a [routerLink]="['/login']">Login</a>
  </div>
</div>
